import {
  type DropdownMenuSubTriggerProps,
  Portal,
  Sub,
  SubContent,
  SubTrigger,
} from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';
import { DecoratedMenuItemContent } from './DropdownItem';

export type SubMenuProps = {
  /** items to be rendered by the sub menu (should be DropdownItem */
  children: ReactNode;
  /** props to pass to the sub menu trigger */
  triggerProps: SubMenuTriggerProps;
  /** content width */
  width?: number | string;
  /** optional z-index (should not be lower than main menu's value */
  zIndex?: number;
};

type SubMenuTriggerProps = DropdownMenuSubTriggerProps & {
  disabled?: boolean;
  label?: string | ReactNode;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  children?: ReactNode;
};

const SubMenuTrigger = ({
  disabled,
  iconLeft,
  label,
  iconRight,
  children,
}: SubMenuTriggerProps) =>
  children ? (
    <SubTrigger
      className="group data-[highlighted]:bg-ds-natural-50 outline-none data-[disabled]:pointer-events-none cursor-pointer"
      disabled={disabled}
    >
      {children}
    </SubTrigger>
  ) : (
    <SubTrigger
      className="group data-[highlighted]:bg-ds-natural-50 outline-none data-[disabled]:pointer-events-none"
      disabled={disabled}
    >
      <DecoratedMenuItemContent {...{ label, disabled, iconLeft, iconRight }} />
    </SubTrigger>
  );

export const SubMenu = ({
  children,
  width,
  zIndex,
  triggerProps,
}: SubMenuProps) => {
  return (
    <Sub>
      <SubMenuTrigger {...triggerProps} />
      <Portal>
        <SubContent
          loop
          className="bg-ds-accent3-100 rounded-lg p-1 shadow-xl"
          style={{ width, zIndex: zIndex ?? 9999 }}
          sideOffset={2}
          alignOffset={-5}
        >
          {children}
        </SubContent>
      </Portal>
    </Sub>
  );
};
